import moment from 'moment'
import 'moment/locale/sl'

export function formatDate(dateTime) {

        var dateTime = new Date(dateTime*1000);
        var time = moment(dateTime);
        time.locale('sl');
        return time.format('LLLL');
}